import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkharadi() {



    const cardData = {

keyword: "Cab Service in Kharadi",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Kharadi for IT professionals, daily commuters, families, and business travelers. We provide quick local rides, airport transfers, railway station drops, and comfortable outstation travel from Kharadi to all major destinations. Our fleet includes well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional and verified chauffeurs. With 24/7 availability, on-time pickup, and transparent pricing, Rising Cab Service ensures a safe, smooth, and hassle-free travel experience in Kharadi and nearby areas.",

topPlaces: [
  
    {
        title: "Mahabaleshwar",
        description:
            " draws tourists with its cool climate, dense forests, and breathtaking viewpoints across the Western Ghats. Strawberry farms, waterfalls, and boating spots enhance the overall hill-station experience. The region offers a perfect mix of nature, sightseeing, and relaxed holiday vibes."
    },
    {
        title: "Panchgani",
        description:
            " offers a calm hill-station experience centered around the vast Table Land plateau and scenic valley views. Strawberry farms, colonial-era charm, and pleasant weather create a peaceful environment for families and couples. Its slower pace makes it ideal for unwinding away from city life."
    },
    {
        title: "Alibaug",
        description:
            " brings a coastal escape with clean beaches, historic sea forts, and refreshing sea breeze experiences. Ferry rides and beachside activities add adventure and fun to short trips from Pune. Fresh seafood and sunset views enhance the relaxed coastal atmosphere."
    },
    {
        title: "Matheran",
        description:
            " provides a unique pollution-free hill retreat where vehicles are completely banned, preserving its natural charm. Dense forests, toy train rides, and multiple viewpoints offer scenic walking trails throughout the region. Its quiet surroundings make it perfect for slow, nature-focused travel."
    },
      {
        title: "Lonavala",
        description:
            " stands out as one of the most visited weekend escapes from Pune, surrounded by lush valleys, waterfalls, and misty hills. Monsoon season transforms the entire region into a green paradise, making it ideal for nature walks, short treks, and photography. Local attractions, caves, and famous chikki shops add to the overall travel experience."
    },
    {
        title: "Khandala",
        description:
            " attracts travelers with its dramatic cliffs, foggy mountains, and iconic viewpoints such as Tiger’s Leap. Located close to Lonavala, it offers quick road-trip access from Pune for a refreshing break. Scenic drives, monsoon landscapes, and peaceful hill views make it a favorite among weekend explorers."
    },
    {
        title: "Lavasa",
        description:
            " features a planned lakeside township designed with colorful architecture inspired by European towns. Visitors enjoy relaxed walks along the promenade, boating activities, and resort stays surrounded by hills. Its calm environment makes it suitable for family outings and short leisure trips from Pune."
    },
    {
        title: "Bhimashankar",
        description:
            " combines spiritual importance with natural beauty, located deep within the Western Ghats. The temple attracts pilgrims while surrounding forests provide trekking routes and wildlife sightings. Its peaceful environment makes it both a religious and nature-friendly destination."
    },
    {
        title: "Tapola",
        description:
            " offers a quiet lakeside escape often called the Mini Kashmir of Maharashtra, surrounded by calm waters and green hills. Boating, camping, and photography are popular activities in this serene environment. Its less crowded nature makes it perfect for peaceful weekend retreats."
    },
    {
        title: "Kolad",
        description:
            " delivers an adventure-packed experience centered around white-water rafting on the Kundalika River. Monsoon season boosts water levels, making it a hotspot for thrill-seekers and group trips. Camping, kayaking, and riverside stays complete the outdoor adventure feel."
    }
],



services: [
    {
        name: "Taxi Service in Kharadi",
        description:
            "Rising Cab Service offers Taxi Service in Kharadi for residents, IT professionals, corporate employees, and travelers looking for safe, reliable, and comfortable transportation. We provide well-maintained AC vehicles, experienced drivers, and 24x7 availability for local commuting, airport transfers, and long-distance travel. Our focus is on punctual pickups, smooth rides, and affordable pricing for all types of travel needs across Kharadi and Pune."
    },
    {
        name: "Kharadi Cab Service",
        description:
            "Our Kharadi Cab Service ensures quick and convenient transportation for daily commuters, families, and business travelers. Rising Cab Service offers clean vehicles, professional chauffeurs, and flexible booking options for local rides, office travel, and outstation trips with complete comfort and reliability."
    },
    {
        name: "Kharadi Taxi Service",
        description:
            "Rising Cab Service provides Kharadi Taxi Service with safe, affordable, and comfortable rides across Pune and Maharashtra. Whether it is a short city trip or a long-distance journey, our experienced drivers ensure smooth travel with timely service and customer satisfaction."
    },
    {
        name: "Best Cab Service in Kharadi",
        description:
            "Book Best Cab Service in Kharadi with Rising Cab Service for premium transportation, transparent pricing, and 24x7 support. We ensure high-quality service with well-maintained vehicles and professional drivers suitable for families, corporate clients, and solo travelers."
    },
    {
        name: "Online Cab Booking Kharadi",
        description:
            "Our Online Cab Booking Kharadi system allows quick and easy cab reservations with instant confirmation, multiple vehicle options, and transparent pricing. Rising Cab Service ensures a seamless booking experience for both local and outstation travel needs."
    },
    {
        name: "Cab Hire in Kharadi",
        description:
            "Rising Cab Service offers Cab Hire in Kharadi for hourly rentals, full-day trips, corporate travel, and personal transportation needs. We provide flexible packages with professional drivers and comfortable vehicles for a smooth travel experience."
    },
    {
        name: "Taxi Booking Kharadi",
        description:
            "Book Taxi Booking Kharadi with Rising Cab Service for fast, reliable, and affordable transportation. We ensure timely service, clean vehicles, and experienced drivers for all types of travel requirements."
    },
    {
        name: "Outstation Cab Service Kharadi",
        description:
            "Rising Cab Service provides Outstation Cab Service Kharadi for long-distance travel to destinations like Mumbai, Shirdi, Nashik, Goa, Kolhapur, Mahabaleshwar, and more. We offer comfortable rides, experienced drivers, and flexible one-way or round-trip options for safe intercity travel."
    },
    {
        name: "Cab Service in Kharadi Pune",
        description:
            "Our Cab Service in Kharadi Pune ensures reliable local and intercity transportation with 24x7 availability, professional drivers, and well-maintained vehicles for all travel needs."
    },
    {
        name: "Taxi Service in Kharadi Pune",
        description:
            "Rising Cab Service offers Taxi Service in Kharadi Pune for safe and comfortable travel across the city and outstation routes with affordable pricing and quick response time."
    },
    {
        name: "Cheap Cab Service Kharadi",
        description:
            "Book Cheap Cab Service Kharadi with Rising Cab Service for budget-friendly travel without compromising safety and comfort. We offer economical rides for daily commuting and short trips."
    },
    {
        name: "Affordable Taxi Service Kharadi",
        description:
            "Our Affordable Taxi Service Kharadi provides cost-effective transportation solutions for families, office employees, and travelers with clean vehicles and reliable drivers."
    },
    {
        name: "24 Hours Cab Service Kharadi",
        description:
            "Rising Cab Service offers 24 Hours Cab Service Kharadi ensuring round-the-clock availability for local travel, airport transfers, emergencies, and outstation trips."
    },
    {
        name: "One Way Cab Service Kharadi",
        description:
            "Our One Way Cab Service Kharadi is ideal for budget travelers who need convenient drop services without return booking, offering flexible and affordable travel options."
    },
    {
        name: "Round Trip Cab Service Kharadi",
        description:
            "Rising Cab Service provides Round Trip Cab Service Kharadi with complete travel packages including pickup, waiting time, sightseeing (if needed), and return journey for convenience."
    },
    {
        name: "Instant Cab Booking Kharadi",
        description:
            "Book Instant Cab Booking Kharadi with Rising Cab Service for quick cab availability, fast confirmation, and hassle-free transportation for all travel needs."
    },
    {
        name: "Kharadi to Mumbai Cab",
        description:
            "Rising Cab Service offers Kharadi to Mumbai Cab for safe and comfortable intercity travel with experienced drivers, smooth highway rides, and flexible booking options."
    },
    {
        name: "Kharadi to Shirdi Cab",
        description:
            "Book Kharadi to Shirdi Cab with Rising Cab Service for a peaceful pilgrimage to Sai Baba temple with comfortable AC vehicles and reliable service."
    },
    {
        name: "Kharadi to Nashik Cab",
        description:
            "Our Kharadi to Nashik Cab service ensures safe and smooth travel for family trips, pilgrimages, and business journeys with professional drivers."
    },
    {
        name: "Kharadi to Goa Cab",
        description:
            "Rising Cab Service provides Kharadi to Goa Cab for a relaxing beach vacation with safe driving, clean vehicles, and comfortable long-distance travel experience."
    },
    {
        name: "Kharadi to Mahabaleshwar Cab",
        description:
            "Book Kharadi to Mahabaleshwar Cab for scenic hill station travel with experienced drivers and comfortable rides for families and couples."
    },
    {
        name: "Kharadi to Lonavala Cab",
        description:
            "Rising Cab Service offers Kharadi to Lonavala Cab for quick weekend getaways with safe, affordable, and comfortable transportation."
    },
    {
        name: "Kharadi to Kolhapur Cab",
        description:
            "Our Kharadi to Kolhapur Cab service ensures smooth pilgrimage and family travel with reliable drivers and well-maintained vehicles."
    },
    {
        name: "Kharadi to Pandharpur Cab",
        description:
            "Rising Cab Service provides Kharadi to Pandharpur Cab for devotees visiting Lord Vitthal temple with comfortable and safe travel arrangements."
    },
    {
        name: "Kharadi to Bhimashankar Cab",
        description:
            "Book Kharadi to Bhimashankar Cab for a spiritual Jyotirlinga journey with safe driving, experienced chauffeurs, and comfortable vehicles."
    },
    {
        name: "Kharadi to Aurangabad Cab",
        description:
            "Rising Cab Service offers Kharadi to Aurangabad Cab for heritage and tourism travel with professional drivers and reliable intercity service."
    },
    {
        name: "Book Cab in Kharadi Now",
        description:
            "Book Cab in Kharadi Now with Rising Cab Service for instant confirmation, quick pickups, and reliable transportation for all travel needs."
    },
    {
        name: "Instant Taxi Booking Kharadi",
        description:
            "Our Instant Taxi Booking Kharadi service ensures fast cab availability with easy booking, transparent pricing, and quick response time."
    },
    {
        name: "Trusted Cab Service Kharadi",
        description:
            "Rising Cab Service is a Trusted Cab Service Kharadi known for safety, reliability, professional drivers, and high-quality customer support."
    },
    {
        name: "Best Rated Taxi Service Kharadi",
        description:
            "Rising Cab Service provides Best Rated Taxi Service Kharadi with top customer reviews, clean vehicles, and excellent service quality for all travel needs."
    },
    {
        name: "Outstation Cab Service Kharadi",
        description:
            "Our Outstation Cab Service Kharadi offers long-distance travel to major destinations across Maharashtra with safe, comfortable, and affordable rides."
    },
    {
        name: "Innova Crysta on Rent in Kharadi",
        description:
            "Book Innova Crysta on Rent in Kharadi with Rising Cab Service for premium comfort, spacious seating, and luxury travel experience ideal for family and group trips."
    }
],

tableData: [
    ["Taxi Service in Kharadi", "Kharadi Cab Service"],
    ["Kharadi Taxi Service", "Best Cab Service in Kharadi"],
    ["Online Cab Booking Kharadi", "Cab Hire in Kharadi"],
    ["Taxi Booking Kharadi", "Outstation Cab Service Kharadi"],
    ["Cab Service in Kharadi Pune", "Taxi Service in Kharadi Pune"],
    ["Cheap Cab Service Kharadi", "Affordable Taxi Service Kharadi"],
    ["24 Hours Cab Service Kharadi", "One Way Cab Service Kharadi"],
    ["Round Trip Cab Service Kharadi", "Instant Cab Booking Kharadi"],
    ["Kharadi to Mumbai Cab", "Kharadi to Shirdi Cab"],
    ["Kharadi to Nashik Cab", "Kharadi to Goa Cab"],
    ["Kharadi to Mahabaleshwar Cab", "Kharadi to Lonavala Cab"],
    ["Kharadi to Kolhapur Cab", "Kharadi to Pandharpur Cab"],
    ["Kharadi to Bhimashankar Cab", "Kharadi to Aurangabad Cab"],
    ["Book Cab in Kharadi Now", "Instant Taxi Booking Kharadi"],
    ["Trusted Cab Service Kharadi", "Best Rated Taxi Service Kharadi"],
    ["Outstation Cab Service Kharadi", "Innova Crysta on Rent in Kharadi"]
],





whychoose: [
    {
        WhyChooseheading: "Smart Travel Solutions Across Kharadi",
        WhyChoosedescription: "Rising Cab Service offers dependable transportation for residents, professionals, visitors, and families traveling within Kharadi and nearby areas."
    },
    {
        WhyChooseheading: "Excellent Choice for Corporate Mobility",
        WhyChoosedescription: "Employees working in EON IT Park, World Trade Center, and business centers across Kharadi can rely on our punctual and convenient cab services."
    },
    {
        WhyChooseheading: "Suitable for Every Travel Occasion",
        WhyChoosedescription: "Whether it's an airport transfer, office commute, shopping trip, business meeting, sightseeing tour, or outstation journey, we provide the right travel solution."
    },
    {
        WhyChooseheading: "Modern Fleet with Multiple Vehicle Options",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on passenger requirements and travel preferences."
    },
    {
        WhyChooseheading: "Seamless Pickup and Drop Assistance",
        WhyChoosedescription: "Our cab service covers residential complexes, corporate offices, hotels, hospitals, educational institutes, and commercial locations throughout Kharadi."
    },
    {
        WhyChooseheading: "Flexible Travel Arrangements",
        WhyChoosedescription: "Customers can schedule rides according to their preferred timing, whether for early morning departures, late-night arrivals, or full-day requirements."
    },
    {
        WhyChooseheading: "Professional Drivers and Clean Vehicles",
        WhyChoosedescription: "Every ride is supported by courteous drivers and properly maintained vehicles to ensure a comfortable and pleasant journey."
    },
    {
        WhyChooseheading: "Popular Among Business and Family Travelers",
        WhyChoosedescription: "Our services are frequently chosen for corporate travel, family outings, airport transfers, weekend trips, and special occasions."
    }
]
};

const faqData = [
    {
        question: "Why is Kharadi one of the busiest travel hubs in Pune?",
        answer: "Kharadi is home to major IT parks, commercial offices, residential communities, and business centers, creating high demand for reliable transportation."
    },
    {
        question: "Can travelers arrange airport transportation from Kharadi?",
        answer: "Yes, convenient pickup and drop services are available between Kharadi and Pune Airport."
    },
    {
        question: "Which destinations are commonly booked from Kharadi?",
        answer: "Popular routes include Mumbai, Shirdi, Nashik, Mahabaleshwar, Lonavala, Pune Airport, and nearby business districts."
    },
    {
        question: "Are transportation services available for office staff?",
        answer: "Yes, many professionals use our service for daily commuting and business-related travel."
    },
    {
        question: "What vehicle types can customers choose from?",
        answer: "Available options include Sedan cars, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and larger group vehicles."
    },
    {
        question: "Do families frequently use this cab service?",
        answer: "Yes, families regularly book our vehicles for local travel, vacations, functions, and sightseeing tours."
    },
    {
        question: "Can group transportation be arranged from Kharadi?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for group tours, events, and family gatherings."
    },
    {
        question: "Is advance reservation helpful during busy periods?",
        answer: "Yes, booking in advance helps ensure preferred vehicle availability during weekends, holidays, and peak travel seasons."
    },
    {
        question: "Are one-way and return-trip bookings available?",
        answer: "Yes, customers can select either one-way rides or round-trip travel packages according to their plans."
    },
    {
        question: "What is the easiest way to reserve a cab in Kharadi?",
        answer: "Customers can schedule a ride through a phone call, WhatsApp inquiry, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akshay More",
        feedback:
            "Regular airport and office travel from Kharadi has become far more convenient since choosing Rising Cab Service. The punctuality and ride quality have been consistently excellent.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shweta Kulkarni",
        feedback:
            "A weekend family excursion was handled smoothly from start to finish. The vehicle was comfortable, the driver was courteous, and the overall experience was highly satisfying.",
        rating: 5
    }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Kharadi",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-kharadi.jpg",
"description": "Book Cab Service in Kharadi with Rising Cab Service for local travel, airport transfers, corporate rides, and outstation trips. Enjoy safe, affordable, and 24/7 reliable taxi service in Kharadi with AC cars and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-kharadi"
}
};









    return (
        <div>

<Helmet>
  <title>Cab Service in Kharadi | 24x7 Local & Outstation Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Kharadi for local rides, airport transfers, corporate travel, and outstation trips. Affordable 24/7 taxi service with AC cabs and professional drivers."
/>

<meta
 name="keywords"
 content="Taxi Service in Kharadi, Kharadi Cab Service, Kharadi Taxi Service, Best Cab Service in Kharadi, Online Cab Booking Kharadi, Cab Hire in Kharadi, Taxi Booking Kharadi, Outstation Cab Service Kharadi, Cab Service in Kharadi Pune, Taxi Service in Kharadi Pune, Cheap Cab Service Kharadi, Affordable Taxi Service Kharadi, 24 Hours Cab Service Kharadi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinkharadi;